var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { customFetch } from "@filadd/phi-plus-core";
import { useQuery, } from "@tanstack/react-query";
import { NOTIFICATIONS_API_BASE_PATH, NOTIFICATIONS_KEY_PREFIX, } from "./constants";
const generateNotificationCountQueryKey = () => [NOTIFICATIONS_KEY_PREFIX, "count"];
const fetchNotificationCount = (_a) => __awaiter(void 0, [_a], void 0, function* ({ meta: { baseURL, authToken, locale } = {}, }) {
    if (baseURL == null) {
        throw new Error("baseURL in meta required");
    }
    const response = yield customFetch(`${NOTIFICATIONS_API_BASE_PATH}/inapp/count/`, {
        baseURL,
        authToken,
        locale,
    });
    return response.count;
});
export const useNotificationCount = (_a = {}) => {
    var options = __rest(_a, []);
    return useQuery(Object.assign({ queryKey: generateNotificationCountQueryKey(), queryFn: fetchNotificationCount }, options));
};
useNotificationCount.prefetchQuery = (queryClient, options) => queryClient.prefetchQuery(Object.assign(Object.assign({}, options), { queryKey: generateNotificationCountQueryKey(), queryFn: fetchNotificationCount }));
useNotificationCount.generateKey = generateNotificationCountQueryKey;
//# sourceMappingURL=useNotificationCount.js.map